import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, sqsMessageBatchSize } = formData;
  const handleSubmit = () => {
    if (formError) {
      return;
    }
    if (pollingInterval.value < 1) {
      setFormError({
        full_message: "Please provide valid polling interval",
        nice_message: "Minimum allowable polling interval is 1 minute."
      });
      return;
    }
    if ((sqsMessageBatchSize == null ? void 0 : sqsMessageBatchSize.value) && (sqsMessageBatchSize.value < 1 || sqsMessageBatchSize.value > 10)) {
      setFormError({
        full_message: "Please provide valid SQS Message Batch Size.",
        nice_message: "Please select SQS Message Batch Size between 1 - 10."
      });
      return;
    }
    setFormError(null);
    onSubmit();
  };
  const handleSqsMessageBatchSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      name: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue || "",
      min: "1",
      max: "60",
      step: "1",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from AWS Security Lake. The smallest allowable interval is 1 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleSqsMessageBatchSizeChange }));
};
export default StepSubscribe;
